import HtmlRenderContainer from '@/components/content-management/html-render-container';
import QuizOption from '@/components/content-management/quiz/render/option';
import QuizFeedback from '@/components/content-management/quiz/render/feedback';

import QuizMixin from '@/mixins/quiz';

export default {
  props: {
    questions: {
      type    : Array,
      default : () => ([])
    },
    content: {
      type    : Object,
      default : () => ({})
    },
    attempt: {
      type    : Object,
      default : () => ({})
    }
  },
  components: {
    QuizOption,
    QuizFeedback,
    HtmlRenderContainer
  },
  mixins  : [QuizMixin],
  methods : {
    getLetter(index) {
      return String.fromCharCode(97 + index);
    },
    getOptionStatusText(questionId, option, attempt) {
      if (this.isOptionSelectedByStudent(questionId, option.optionId, attempt) && this.isOptionCorrect(option)) {
        return this.$t('student.quiz.attemptSummaryModal.questionsSummary.studentRightAnswer');
      } else if (this.isOptionSelectedByStudent(questionId, option.optionId, attempt) && !this.isOptionCorrect(option)) {
        return this.$t('student.quiz.attemptSummaryModal.questionsSummary.studentWrongAnswer');
      } else if (!this.isOptionSelectedByStudent(questionId, option.optionId, attempt) && this.isOptionCorrect(option)) {
        return this.$t('student.quiz.attemptSummaryModal.questionsSummary.quizRightAnswer');
      }
    },
    getOptionType({ question, option, content, attempt }) {
      if (!this.shouldShowFeedback(content) && this.isOptionSelectedByStudent(question.questionId, option.optionId, attempt)) {
        return 'selected';
      } else if (this.shouldShowFeedback(content) && !this.isOptionSelectedByStudent(question.questionId, option.optionId, attempt) && this.isOptionCorrect(option)) {
        return 'default';
      } else if (this.shouldShowFeedback(content) && this.isOptionSelectedByStudent(question.questionId, option.optionId, attempt) && this.isOptionCorrect(option)) {
        return 'correct';
      } else if (this.shouldShowFeedback(content) && this.isOptionSelectedByStudent(question.questionId, option.optionId, attempt) && !this.isOptionCorrect(option)) {
        return 'incorrect';
      } else if (this.shouldShowFeedback(content) && !this.isOptionSelectedByStudent(question.questionId, option.optionId, attempt)) {
        return 'disabled';
      }
    }
  }
};
